/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'internal_parameter_coordination': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M18 12.251V4a1 1 0 00-1-1H4a1 1 0 00-1 1v16.491a1 1 0 001 1h13a1 1 0 001-1v-1.74" _stroke="currentColor" stroke-width="1.5"/><path pid="1" d="M7 7.626h4M7 11.126h7" _stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><path pid="2" fill-rule="evenodd" clip-rule="evenodd" d="M20.25 14.414V12h1.5v2.414a1.75 1.75 0 01-1.75 1.75h-4.232l1.271 1.315-1.078 1.042-3.022-3.126 3.04-2.935 1.042 1.08-1.164 1.124H20a.25.25 0 00.25-.25z" _fill="currentColor"/>'
  }
})
